<template>
  <div id="app">
    <date-picker></date-picker>
  </div>
</template>

<script>
import DatePicker from './components/DatePicker.vue'

export default {
  name: 'app',
  components: {
    DatePicker
  }
}
</script>

<style>
</style>
